import { Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import dayjs from "dayjs"
import { TransportationExpenseCard } from "./TransportationExpenseCard"
import {
    TransportationExpense,
    displayYearMonth,
    groupExpensesByMonth
} from "@/model/transportationExpense"
import { DateString, formatDate } from "@/utils/dateString"
import { showJpYen } from "@/utils/showJpYen"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"

export const TransportationExpenseList = ({
    expenses,
    onEdit
}: {
    expenses: TransportationExpense[]
    onEdit: (expense: TransportationExpense) => void
}) => {
    const { t } = useTranslation()

    const today: DateString = formatDate(dayjs())

    if (expenses.length === 0) {
        return (
            <Typography
                css={css`
                    color: ${theme.palette.gray[500]};
                `}
            >
                {t("申請履歴はありません")}
            </Typography>
        )
    }

    return (
        <div
            css={css`
                display: grid;
                gap: 20px;
            `}
        >
            {groupExpensesByMonth(expenses).map(
                ({ yearMonth, expenses: monthlyExpenses, totalAmount }) => (
                    <div
                        key={yearMonth}
                        css={css`
                            display: grid;
                            gap: 12px;
                        `}
                    >
                        <div
                            css={css`
                                display: flex;
                                gap: 8px;
                                align-items: baseline;
                                justify-content: space-between;
                                padding-bottom: 6px;
                                border-bottom: 1px solid
                                    ${theme.palette.gray[300]};
                            `}
                        >
                            <Typography
                                variant="h4"
                                css={css`
                                    font-weight: bold;
                                `}
                            >
                                {displayYearMonth(yearMonth)}
                            </Typography>
                            <Typography
                                variant="body2"
                                css={css`
                                    color: ${theme.palette.gray[700]};
                                    white-space: nowrap;
                                `}
                            >
                                {`${t("{{count}}件", {
                                    params: { count: monthlyExpenses.length }
                                })}・${showJpYen(totalAmount)}`}
                            </Typography>
                        </div>

                        <div
                            css={css`
                                display: grid;
                                gap: 12px;
                            `}
                        >
                            {monthlyExpenses.map(expense => (
                                <TransportationExpenseCard
                                    key={expense.id}
                                    expense={expense}
                                    today={today}
                                    onEdit={onEdit}
                                />
                            ))}
                        </div>
                    </div>
                )
            )}
        </div>
    )
}
